
export class CustomLayoutType {
  Id: number;
  Name = '';
}
